import React, { useContext } from 'react';
import { Scenario } from '../../data/constants';
import { ArrowRight20 } from '@carbon/icons-react';
import { IntroInterface } from '../../lib/type';
import { Button } from 'carbon-components-react';
import { layoutContext } from '../LeaderAssesssment';
import PublicImage from 'src/common/components/PublicImage';
import './Intro.scss';

interface introProps {
  contents: IntroInterface;
}

const Intro = (introProps: introProps) => {
  const { contents } = introProps;
  const { setCurrentScenario } = useContext(layoutContext);

  return (
    <div className="leadership-assesssment__intro bx--row">
      <div className="leadership-assesssment__intro-content bx--col-lg-8 bx--col-md-8">
        <div className="leadership-assesssment__intro-content-text">
          <div>
            <h1 className="leadership-assesssment__intro-title bx--col-lg-16 bx--col-md-8">
              {contents.title}
            </h1>
            <p className="leadership-assesssment__intro-subtitle bx--col-lg-16 bx--col-md-8">
              {contents.copy}
            </p>
          </div>
        </div>
        <Button
          className="leadership-assesssment__intro-btn bx--btn"
          onClick={() => setCurrentScenario(Scenario.questions)}
        >
          {contents.button}
          <ArrowRight20 />
        </Button>
      </div>
      <div className="leadership-assesssment__intro-container bx--col-lg-8">
        <PublicImage
          imgPath={contents.imageSrc}
          widgetId="leadership-assessment"
          alt={'alt'}
          className="leadership-assesssment__intro-img"
        />
      </div>
    </div>
  );
};

export default Intro;
